import { render, staticRenderFns } from "./ProductCertificate.vue?vue&type=template&id=161ebf82&scoped=true"
import script from "./ProductCertificate.vue?vue&type=script&lang=js"
export * from "./ProductCertificate.vue?vue&type=script&lang=js"
import style0 from "./ProductCertificate.scss?vue&type=style&index=0&id=161ebf82&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "161ebf82",
  null
  
)

export default component.exports